import { render, staticRenderFns } from "./SelectCurrencies.vue?vue&type=template&id=6f524c8e&"
import script from "./SelectCurrencies.vue?vue&type=script&lang=js&"
export * from "./SelectCurrencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports